import { LineChart, type LineData, type XAxisPeriod } from 'ComponentLibrary'
import { Box, Stack } from '@mui/material'
import { useState } from 'react'
import { MarketDataChartLegend } from 'ComponentLibrary/src/widgets/MarketDataChart/MarketDataChartLegend'
import type { LineChartTooltipCopy } from 'ComponentLibrary/src/molecules/Chart/LineChartTooltip'

export type MarketDataChartProps = {
    series: LineData[]
    period: XAxisPeriod
    showChange?: boolean
    unit?: string
    chartHeight?: string
    fullWidth?: boolean
    emptyStateTitle?: string
    locale?: string
    chartCopy?: Partial<LineChartTooltipCopy>
}

export function MarketDataChart({
    series,
    unit,
    period = 'year',
    showChange = false,
    chartHeight = '320px',
    fullWidth,
    emptyStateTitle,
    locale,
    chartCopy,
}: MarketDataChartProps) {
    const [activeSeries, setActiveSeries] = useState<LineData[]>(series)
    const hasLegend = series.length > 1

    return (
        <Stack direction={fullWidth ? 'row' : 'column'}>
            <Box height={chartHeight} width={fullWidth && hasLegend ? '80%' : '100%'}>
                <LineChart
                    data={activeSeries}
                    yUnit={unit}
                    period={period}
                    showTrends={showChange}
                    bottomSpace={!fullWidth && hasLegend ? Math.ceil(series.length / 2) * 21 : 0}
                    startAtZero={true}
                    withYearFilter
                    emptyStateTitle={emptyStateTitle}
                    locale={locale}
                    lineChartTooltipCopy={chartCopy}
                />
            </Box>
            {hasLegend && (
                <Box
                    padding={fullWidth ? '16px' : 'unset'}
                    marginTop={fullWidth ? '48px' : undefined}
                    width={fullWidth ? '20%' : '100%'}
                    zIndex={2}
                >
                    <MarketDataChartLegend
                        fullWidth={fullWidth}
                        allSeries={series}
                        activeSeries={activeSeries}
                        setActiveSeries={setActiveSeries}
                    />
                </Box>
            )}
        </Stack>
    )
}
